<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="check-order">
    <div class="order-head">
      <h5>
        {{ $t("checkout.ordersummary") }}
        <router-link to="/cart" class="edit">
          {{ $t("checkout.edit") }}
        </router-link>
      </h5>
    </div>
    <div class="order-body">
      <table v-if="cart" class="table">
        <tbody>
          <tr v-for="product of cart.items" :key="product.id" class="cart_item">
            <td class="product-name">
              <h5>
                <span class="product-sum">× {{ product.quantity }}</span
                >&nbsp; {{ product.name }}
              </h5>
              <div class="product-cat" v-html="product.description" />
            </td>
            <td class="product-total">
              <span class="Price-amount amount">{{
                (product.price.price * product.quantity) | money(currency)
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <form v-if="cart" class="cupon" id="form-coupon">
      <div class="input-group" v-if="requires.coupon_field">
        <input
          v-model="coupon"
          class="form-control"
          :placeholder="$t('cart.coupon')"
          aria-label="Coupon"
          aria-describedby="basic-addon2"
          type="text"
        />
        <div class="input-group-append">
          <button
            :disabled="!coupon"
            class="btn"
            type="button"
            id="btn-apply-coupon"
            @click="applyCoupon"
          >
            {{ $t("cart.apply") }}
          </button>
        </div>
      </div>
      <div v-if="discounts.length > 0" class="total-price-info">
        <h6 class="coupon">
          {{ $t("cart.coupon") }}:
          <span v-for="discount of discounts" :key="discount.code">
            {{ discount.name }}
            <code>({{ discount.code }}) </code><br />
          </span>
        </h6>
      </div>
    </form>
    <!-- /.End of cupon form -->
    <div v-if="cart" class="order-footer">
      <!-- <a href="#" class="have_coupon">Have a coupon?</a> -->
      <div class="total-price-info">
        <h4>
          {{ $t("cart.subtotal") }}: {{ cart.subtotal | money(currency) }}
        </h4>
        <!-- <p>Includes: $6.12 VAT (15% of $39.74)</p> -->
      </div>
      <div v-if="cart.discount !== 0" class="total-price-info">
        <h4>
          {{ $t("cart.discount") }}: {{ cart.discount | money(currency) }}
        </h4>
      </div>
      <div v-if="Number(cart.shipping) > 0" class="total-price-info">
        <h4>
          {{ $t("cart.shipping") }}:
          <span>
            {{ Number(cart.shipping) | money(currency) }}
          </span>
        </h4>
      </div>
      <div v-if="taxes.length > 0" class="total-price-info">
        <h4 v-for="(tax, index) of taxes" :key="index">
          {{ tax.name }}:
          <span>
            {{ Number(tax.amount) | money(currency) }}
          </span>
        </h4>
      </div>
      <div class="total-price-info">
        <h2>
          {{ $t("cart.totalprice") }}:
          <span class="total-price">
            {{ cart.total | money(currency) }}
          </span>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
/* ============
 * Checkout/OrderSummary Component
 * ============
 *
 * Gives an idea how components work.
 */
import { mapState } from "vuex";

export default {
  /**
   * The name of the component.
   */
  name: "CheckoutOrderSummary",
  /**
   * The properties that the component accepts.
   */
  props: {},

  data() {
    return {
      coupon: null,
    };
  },

  /**
   * The computed properties that the component can use.
   */
  computed: {
    ...mapState({
      cart: (state) => state.cart,
      currency: (state) => state.currency,
      discounts: (state) => state.discounts,
      requires: (state) => state.requires,
      taxes: "taxes",
    }),
  },

  mounted() {},

  methods: {
    applyCoupon() {
      if (this.coupon) {
        this.$store.dispatch("applyCoupon", this.coupon);
      }
    },
  },
};
</script>
